function unescapeRefinement(value) {
  return String(value).replace(/^\\-/, '-');
}

export default unescapeRefinement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/unescapeRefinement.js
// module id = null
// module chunks = 